import { render, staticRenderFns } from "./SingleGroupChart.vue?vue&type=template&id=aaa9d90e&"
import script from "./SingleGroupChart.vue?vue&type=script&lang=ts&"
export * from "./SingleGroupChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports